<template>
  <span>
    <v-text-field
      :value="auFromatted"
      @input="au2formatted"
      :label="label"
      prepend-icon="far fa-calendar-alt"
      @click:prepend="toggleMenu"
      required
      mask="##/##/####"
      return-masked-value
      :disabled="disabled"
      :error-messages="errorMessages"
      placeholder="DD/MM/YYYY"
    />
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="formatted"
      lazy
      transition="scale-transition"
      absolute
      full-width min-width="290px"
      :position-x="menuX"
      :position-y="menuY"
    >
      <v-date-picker
        ref="picker"
        v-model="formatted"
        scrollable header-color="secondary"
        :min="min || undefined"
        :max="max || undefined"
        @change="save(formatted)"
      >
        <div v-if="!dob">
          <v-spacer />
          <v-btn flat color="primary" @click="save(existing); menu = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="save(formatted)">OK</v-btn>
        </div>
      </v-date-picker>
    </v-menu>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: [Date, String],
      default: () => new Date(),
    },
    min: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    dob: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      formatted: this.format(this.value),
      menu: false,
      existing: '',
      menuX: 0,
      menuY: 0,
    };
  },
  computed: {
    auFromatted() {
      const [year, month, day] = this.formatted.split('-');
      return `${day}/${month}/${year}`;
    },
  },
  methods: {
    format(v) { return (new Date(v)).toISOString().substr(0, 10); },
    au2formatted(v) {
      const [day, month, year] = v.split('/');
      if (!/^\d{4}$/.test(year)) return;
      this.formatted = `${year}-${month}-${day}`;
    },
    save(v) { this.$refs.menu.save(v); },
    toggleMenu(e) {
      e.preventDefault();
      if (this.menu) {
        this.menu = false;
        return;
      }
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.$nextTick(() => {
        this.menu = true;
      });
    },
  },
  watch: {
    value() {
      this.formatted = this.format(this.value);
    },
    formatted() {
      this.$emit('update:form', this.formatted);
      if (this.formatted !== this.format(this.value)) {
        this.$emit('input', new Date(this.formatted));
      }
    },
    menu(val) {
      if (this.disabled) {
        this.$nextTick(() => { this.menu = false; });
        return;
      }
      if (val) {
        if (this.dob) this.$nextTick(() => { this.$refs.picker.activePicker = 'YEAR'; });
        this.existing = this.formatted;
      }
    },
  },
  mounted() { this.$emit('update:form', this.formatted); },
  updated() { this.$emit('update:form', this.formatted); },
};
</script>
